import { enumToSelectList, JourneysCreationTypeEnum } from "@ryde/shared";

export enum JourneyDuplicateFormFieldsEnum {
  Name = "name",
  CreationSource = "creationSource",
  DayType = "dayType",
  DayGroup = "dayGroup",
  DateFrom = "dateFrom",
  DateTo = "dateTo",
}

export const JourneysCreationTypeSelectList = enumToSelectList(
  JourneysCreationTypeEnum,
);
